/** Reusable style mapping helpers to replace nested ternaries across the app. */

const LEAVE_TYPE_STYLES = {
  conge:   { label: 'Conge',        bg: '#E3F2FD', color: '#1565C0' },
  maladie: { label: 'Arret maladie', bg: '#FFF3E0', color: '#EF6C00' },
  absence: { label: 'Absence',      bg: '#F4F5F7', color: '#5E5F66' },
};

export const getLeaveTypeStyle = (type) => LEAVE_TYPE_STYLES[type] || LEAVE_TYPE_STYLES.absence;

export const getLeaveTypeLabel = (type) => (LEAVE_TYPE_STYLES[type] || LEAVE_TYPE_STYLES.absence).label;

const SEVERITY_ORDER = { danger: 0, warning: 1, info: 2 };
export const compareSeverity = (a, b) => (SEVERITY_ORDER[a] ?? 3) - (SEVERITY_ORDER[b] ?? 3);

export const getProgressColor = (pct) => {
  if (pct > 80) return '#C62828';
  if (pct > 60) return '#EF6C00';
  return '#2E7D32';
};

export const getCalendarDayStyle = (today, hasTasks, isWeekend) => {
  if (today) return { backgroundColor: 'var(--primary, #002FA7)', color: 'white' };
  if (hasTasks) return { backgroundColor: '#E3F2FD', color: '#1565C0' };
  if (isWeekend) return { backgroundColor: '#FAFAFA', color: '#9E9E9E' };
  return { backgroundColor: 'transparent', color: '#0A0B10' };
};

export const getTaskCountColor = (count) => {
  if (count > 2) return '#C62828';
  if (count > 1) return '#EF6C00';
  return '#1565C0';
};
